import React, { useContext, useEffect, useRef, useState } from 'react';
import { systemCode, xs_languageCode } from '../../.';
import { ShopContext } from '../shop/ShopConf';
import { getConfiguration } from '../utils';
import { UserContext } from './UserConf';
import $ from 'jquery';

export const BonusContext = React.createContext(null);

function BonusConf(props) {
	const ctxs = useRef({}).current;
	ctxs.userContext = useContext(UserContext);
	ctxs.shopContext = useContext(ShopContext);
	
    const [bonusContext, setBonusContext] = useState({
		hashIntegrity: null,
	    bonusData : null,
	    intervalId : null,
	    pollingEnabled : true,
	    isVirtual : false,

	    update : function(updt) {
			// updating temporary
			for(let ko in updt){
				const val = updt[ko];
				ctxs.bonusContext[ko] = val;
			}
			//update effectly
			setBonusContext(prev => {
                return {...prev, ...updt};
            });
        },
        	    
	    setVirtual : function(isVirtual) {
	    	ctxs.bonusContext.update({isVirtual});
	    },
	    
	    loadBonus : function(syncCall) {
	    	loadBonusData(syncCall, ctxs.bonusContext.isVirtual, (response) => {
	    		if(!response){
		    		// if errors, retry
		    		console.error("ERRORE CHIAMATA BONUS: RIPROVO");
		    		setTimeout(() => {
			    		ctxs.bonusContext.loadBonus(syncCall);	    		
		    		}, 1000);    				
					return;	    		
	    		}
	    		if(response.reloadBrowserId){
	    		    let mustBeReloaded = false;
	    		    const localStorageRBI = localStorage.getItem("xsp_reloadBrowserId");
					if(localStorageRBI !== response.reloadBrowserId){
						localStorage.setItem("xsp_reloadBrowserId", response.reloadBrowserId);
						mustBeReloaded = true;
						
					}
		    		if(mustBeReloaded){
		    			const isShopBusy = ctxs.shopContext.enabled && !ctxs.shopContext.busy;
		    			if(isShopBusy){
			    			let interval = setInterval(() => {
			    				const checkBusy = ctxs.shopContext.enabled && !ctxs.shopContext.busy;
			    				if(!checkBusy){
			    					window.location.reload();
			    					clearInterval(interval);
			    				}
			    			
			    			}, 1000);
			    		}
			    		else{
			    			window.location.reload();
			    		}
		    		}
	    		}
	    		else{
					localStorage.removeItem("xsp_reloadBrowserId");
				}

	    		ctxs.bonusContext.setBonusData(response);
	    	},
	    	function () {
	    		// if errors, retry
	    		console.error("ERRORE CHIAMATA BONUS: RIPROVO");
	    		setTimeout(() => {
		    		ctxs.bonusContext.loadBonus(syncCall);	    		
	    		}, 1000);
	    		
	    	});  	
	    },
	    
	    setBonusData : function(bonusData) {
	    	ctxs.bonusContext.update({bonusData, hashIntegrity: bonusData?.hashIntegrity});
	    },
	    
	    enablePolling : function() {
	    	ctxs.bonusContext.update({pollingEnabled : true});
	    },
	    disablePolling : function() {
			ctxs.bonusContext.update({pollingEnabled : false});
	    },
	    
	    isMarketAvailableForMultiBonus: function (scomSogei, isLive){
			if(ctxs.bonusContext.bonusData?.bonusMultiple){
				if(isLive && ctxs.bonusContext.bonusData.bonusMultiple.scommesseDaEscludereLive && ctxs.bonusContext.bonusData.bonusMultiple.scommesseDaEscludereLive[scomSogei]){
					return false;				
				}
				if(!isLive && ctxs.bonusContext.bonusData.bonusMultiple.scommesseDaEscluderePrematch && ctxs.bonusContext.bonusData.bonusMultiple.scommesseDaEscluderePrematch[scomSogei]){
					return false;
				}
			}
			return true;   
	    }
    });
    ctxs.bonusContext = bonusContext;
    
    function loadBonusData(syncCall, isPsv, callback, errorCallback) {
		const conf = getConfiguration();
		const url = conf.api.getBonusData;
		let cn = null;
		let pvend = null;
		if(ctxs.shopContext.enabled){
			const shopUser = ctxs.shopContext.getShopUser();
			window.shopUser = shopUser;
			if (shopUser && shopUser.shopBooker) {
				cn = shopUser.cn;
				pvend = shopUser.pvend;
			} else {
				const cnPvend = shopUser && shopUser.servicesMap? shopUser.servicesMap['SPORT'] : null;
				if(cnPvend != null){
					cn = cnPvend.split('/')[0];
					pvend = cnPvend.split('/')[1];
				}				
			}
		}
		else if (conf.cpob?.length > 0){
			cn = conf.cpob.split("_")[0];
			pvend = conf.cpob.split("_")[1];
		}
        const params = {
            systemCode : systemCode,
            lingua: xs_languageCode,
            hash: '',
            token : '',
            cn,
            pvend,
            isPsv : isPsv
        }
       
    	fetchBonusData(url, params, syncCall, (response) => {
    		callback(response);
    	}, 
    	(error) => {
    		errorCallback();
    	}); 	
    
    }
    
    function fetchBonusData (url, params, syncCall, callback, errorCallback){
    	$.ajax({
    		type: "GET",
    		url : url,
    		data: params,
    		async : !syncCall,
    		success : (data) => {
    			if(data != null){
    				callback(JSON.parse(data));
    			}
    		},
    		error : (errorData) => {
    			errorCallback(errorData);
    		}	
       });
    	
    }

    const user = ctxs.userContext.getUser();
    useEffect(() => {
    	if (ctxs.bonusContext.pollingEnabled) {
    		ctxs.bonusContext.setVirtual(props.isVirtual? true:false);
    		ctxs.bonusContext.loadBonus(true);
    		ctxs.bonusContext.intervalId = setInterval(() => {
    			ctxs.bonusContext.loadBonus(false);
    		}, 60000);    		
    	} 
    	else {
    		clearInterval(ctxs.bonusContext.intervalId);
    	}

        // Remove polling when component is unmounted
        return () => {
            clearInterval(ctxs.bonusContext.intervalId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ctxs.bonusContext.pollingEnabled, user.logged, user.accountId, props.isVirtual]);
    
    return (
    	<BonusContext.Provider value={ctxs.bonusContext}>
    	    {props.children}
    	</BonusContext.Provider>
    );
}

export default BonusConf;
